import { render } from "./ShapeSequenceGame.vue?vue&type=template&id=1e8d67eb&scoped=true"
import script from "./ShapeSequenceGame.vue?vue&type=script&lang=js"
export * from "./ShapeSequenceGame.vue?vue&type=script&lang=js"

import "./ShapeSequenceGame.vue?vue&type=style&index=0&id=1e8d67eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8d67eb"]])

export default __exports__